<template>
  <div class="container ancillary-sub-detail-container" v-if="detail">
    <div class="base-info">
      <div class="order-base-header aclry-base-header"><strong>订单号:</strong>{{ detail.orderNo || '--' }}</div>
      <div class="order-gray-table-outer aclry-table-outer">
        <table class="order-gray-table">
          <tr>
            <td>
              <span class="_info-t">产品类型：</span>
              <span class="_info-m r">{{ detail.extProductTypeCn }}</span>
            </td>
            <td>
              <span class="_info-t">订单状态：</span>
              <span class="_info-m r">{{ detail.statusCn }}</span>
            </td>
            <td>
              <span class="_info-t">订单来源：</span>
              <span class="_info-m">{{ detail.source }}</span>
            </td>
            <td>
              <span class="_info-t">预订日期：</span>
              <span class="_info-m">{{ detail.bookingDateTime }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="_info-t">订单金额：</span>
              <span class="_info-m">{{ detail.totalAmount }}元</span>
            </td>
            <td>
              <span class="_info-t">优惠券抵用：</span>
              <span class="_info-m">{{ detail.couponAmount }}元</span>
            </td>
            <td>
              <span class="_info-t">已支付金额：</span>
              <span class="_info-m">{{ detail.payAmount }}元</span>
            </td>
            <td>
              <span class="_info-t">未支付金额：</span>
              <span class="_info-m">{{detail.unpayAmount }}元</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="pass-info">
      <div class="pass-item">
        <div class="order-primary-header aclry-primary-header">
          <l8-icon class="l8-icon" type="icon-lvke"/>
          <span class="header-label">旅客</span>
          <div>
            <span class="header-msg">
              <span>{{ detail.paxSegmentInfoDTO.passengerName }}</span>
              <span>{{ detail.paxSegmentInfoDTO.certificateTypeCn || '证件号' }}：{{ detail.paxSegmentInfoDTO.certificateNo | codeMask({offset: 4, length: 10}) }}</span>
              <span>手机：{{ detail.paxSegmentInfoDTO.mobile || detail.paxSegmentInfoDTO.mobileNo || '--' | codeMask }}</span>
              <span>票号：{{ detail.paxSegmentInfoDTO.ticketNo }}</span>
            </span>
          </div>
        </div>
        <div class="ext-order-table-warp">
          <table class="order-default-table ext-order-table">
            <thead>
            <tr>
              <td>行程</td>
              <td>承运人</td>
              <td>航班日期</td>
              <td>航班号</td>
              <td>起飞时间</td>
              <td>PNR号</td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ detail.paxSegmentInfoDTO.segmentInfo.depAirport }}-{{ detail.paxSegmentInfoDTO.segmentInfo.arrAirport }}</td>
              <td>{{ detail.paxSegmentInfoDTO.segmentInfo.airlineName }}</td>
              <td>{{ detail.paxSegmentInfoDTO.segmentInfo.flightDate }}</td>
              <td>{{ detail.paxSegmentInfoDTO.segmentInfo.flightNo }}</td>
              <td>{{ detail.paxSegmentInfoDTO.segmentInfo.depTime }}</td>
              <td>{{ detail.paxSegmentInfoDTO.segmentInfo.pnrNo }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="ext-product-info">
      <div class="order-primary-header">
        <span class="header-label">产品信息</span>
      </div>
      <div class="ext-order-table-warp">
        <table class="order-default-table ext-order-table">
          <thead>
          <tr>
            <th>产品名称</th>
            <template v-if="detail.extProductType === 'VIPHALL'">
              <th>出港城市</th>
              <th>消费码</th>
              <th>消费码状态</th>
              <th>有效期</th>
              <th>使用日期</th>
              <th>是否打印发票</th>
            </template>
            <template v-if="detail.extProductType === 'MEAL' || detail.extProductType === 'LUGGAGE'">
              <!-- <th>产品状态</th> -->
              <th>数量</th>
            </template>
            <template v-if="detail.extProductType === 'BUYSEAT'">
              <th>座位号</th>
              <th>是否代打登机牌</th>
            </template>
            <template v-if="detail.extProductType === 'SEAT'">
              <th>产品状态</th>
            </template>
            <template v-if="detail.extProductType !== 'SEAT'">
              <th>价格</th>
            </template>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ detail.extTargetProductInfo.name }}</td>
            <template v-if="detail.extProductType === 'VIPHALL'">
              <td>{{ detail.extTargetProductInfo.depName }}</td>
              <td>{{ detail.extTargetProductInfo.serviceCode }}</td>
              <td>{{ detail.extTargetProductInfo.serviceCodeStatusCn }}</td>
              <td>{{ detail.extTargetProductInfo.usefulDate }}</td>
              <td>{{ detail.extTargetProductInfo.usedDate }}</td>
              <td>{{ detail.extTargetProductInfo.invoiceRemark === 'N' ? '未打印' : '已打印' }}</td>
            </template>
            <template v-if="detail.extProductType === 'MEAL' || detail.extProductType === 'LUGGAGE'">
              <!-- <td>{{ detail.extTargetProductInfo.status }}</td> -->
              <td>{{ detail.extTargetProductInfo.number }}</td>
            </template>
            <template v-if="detail.extProductType === 'BUYSEAT'">
              <td>座位号</td>
              <td>是否代打登机牌</td>
            </template>
            <template v-if="detail.extProductType === 'SEAT'">
              <td>{{ detail.statusCn }}</td>
            </template>
            <template v-if="detail.extProductType !== 'SEAT'">
              <td>{{ detail.extTargetProductInfo.amount }}元</td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="order-tips" v-if="detail.extProductType === 'SEAT' && seatTip" v-html="seatTip"></div>
    <div class="order-action-row">
      <a-button type="primary" v-if="showCancelBtn" @click="aclCancelHandler">取消订单</a-button>
      <a-button type="primary" v-if="showRefundBtn" @click="aclRefundHandler">退订订单</a-button>
    </div>
    <!--取消弹窗-->
    <a-modal
      title="提示"
      v-model="cancelModVisible"
      wrapClassName="order-modal"
      :okText="'确定'"
      :cancelText="'取消'"
      :closable="false"
      :confirmLoading="cancelConfirmLoading"
      @ok="cancelConfirmHandler"
    >
      确定取消订单？
    </a-modal>
    <!--退订弹窗-->
    <a-modal
      title="提示"
      v-model="refundModVisible"
      wrapClassName="order-modal"
      :okText="'确定'"
      :cancelText="'取消'"
      :closable="false"
      :confirmLoading="refundConfirmLoading"
      @ok="refundConfirmHandler"
    >
      确定退订订单？
    </a-modal>
  </div>
</template>

<script>
import queryString from 'query-string'
import { queryAncillarySubDetail, cancelExtProduct } from '@/apis/ancillary'
import { refundExtProduct } from '@/apis/order'
import { productTypeMap } from '@/dicts/ancillary'
import { userTypeMap } from '@/dicts/member'

import '@/components/l8-icon'
import '@/assets/css/l8-order-common.less'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}

export default {
  data () {
    return {
      detail: null,
      subOrderId: '',
      subOrderNo: '',
      id: '',

      showCancelBtn: false,
      showRefundBtn: false,

      cancelModVisible: false,
      cancelConfirmLoading: false,

      refundModVisible: false,
      refundConfirmLoading: false,
      airline: mainSettings.airline,
      userId: '',
      seatTip: ''
    }
  },
  created: function () {
    let query = queryString.parse(location.search)
    this.subOrderNo = query.subOrderNo
    this.id = query.id

    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      if (userTypeMap[userInfo.userType] === 'CARRIER') {
        this.userId = query.outUserId
      }
    }
    this.fetchAncillaryDetail()
    this.getCmsData()
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { content } = res?.seatTip
          this.seatTip = content || ''
        })
      } catch (err) {}
    },
    fetchAncillaryDetail: async function () {
      const { airline, subOrderNo, id } = this

      try {
        const res = await queryAncillarySubDetail({
          alineCode: airline,
          orderNo: subOrderNo,
          orderItemServiceDetailId: id
        })

        if (res) {
          this.updateAncillaryDetail(res)
        }
      } catch (err) {
        this.$message.error(err.message || '辅营订单详情获取失败，请稍后重试。')
      }
    },
    updateAncillaryDetail (detail) {
      this.detail = detail
      this.subOrderId = detail.orderId

      let commonObject = {
        name: detail.extraProductInfo.name,
        amount: detail.extraProductInfo.amount
      }

      switch (detail.extProductType) {
        case 'VIPHALL':
          detail.extraProductInfo.viphallProdInfo.serviceCodeStatusCn = productTypeMap[detail.extraProductInfo.viphallProdInfo.serviceCodeStatus]
          detail.extTargetProductInfo = Object.assign(commonObject, detail.extraProductInfo.viphallProdInfo)
          break
        case 'MEAL':
          detail.extraProductInfo.mealsProdInfo.statusCn = productTypeMap[detail.extraProductInfo.mealsProdInfo.status]
          detail.extTargetProductInfo = Object.assign(commonObject, detail.extraProductInfo.mealsProdInfo)
          break
        case 'LUGGAGE':
          detail.extraProductInfo.luggageProdInfo.statusCn = productTypeMap[detail.extraProductInfo.luggageProdInfo.status]
          detail.extTargetProductInfo = Object.assign(commonObject, detail.extraProductInfo.luggageProdInfo)
          break
        case 'BUYSEAT':
          detail.extTargetProductInfo = Object.assign(commonObject, detail.extraProductInfo.buyseatProdInfo)
          break
        // case 'BOARDING':
        //   detail.extTargetProductInfo = {}
        //   break
        // case 'PAYCHARGE':
        //   detail.extTargetProductInfo = {}
        //   break
        // case 'COMSER':
        //   detail.extTargetProductInfo = {}
        //   break
        // case 'ITINERARY':
        //   detail.extTargetProductInfo = {}
        //   break
        // case 'TRANSFER':
        //   detail.extTargetProductInfo = {}
        //   break
        default:
          detail.extTargetProductInfo = Object.assign(commonObject, {})
      }
      this.updateActions(detail)
    },
    updateActions (detail) {
      let status = detail.status

      switch (status) {
        case 'WP': // 等待支付
          this.showCancelBtn = true
          this.showRefundBtn = false
          break
        case 'PF': // 已出票
          this.showCancelBtn = false
          this.showRefundBtn = true
          break
        case 'XX': // 已取消
          this.showCancelBtn = false
          this.showRefundBtn = false
          break
        default :
          this.showCancelBtn = false
          this.showRefundBtn = false
      }

      if (detail.extProductType === 'ITINERARY') {
        this.showRefundBtn = false
      }

      if (detail.extProductType === 'VIPHALL' && ['OVERDUE', 'USED'].indexOf(detail.extraProductInfo.viphallProdInfo.serviceCodeStatus) > -1) {
        this.showRefundBtn = false
      }
    },
    aclCancelHandler () {
      this.cancelModVisible = true
    },
    aclRefundHandler () {
      this.refundModVisible = true
    },
    cancelConfirmHandler () {
      this.cancelExtProduct()
    },
    refundConfirmHandler () {
      this.refundExtProduct()
    },
    async cancelExtProduct () {
      this.cancelConfirmLoading = true

      const { airline, id } = this

      try {
        await cancelExtProduct({
          airline,
          orderId: this.detail.orderId,
          detailIds: [ id ],
          type: 'OTHER'
        })

        this.cancelConfirmLoading = false
        this.cancelModVisible = false
        this.$message.success('辅营订单取消成功，正在刷新订单...', () => {
          window.location.reload()
        })
      } catch (err) {
        this.cancelConfirmLoading = false
        this.cancelModVisible = false
        this.$message.error(err.message || '取消辅营失败，请稍候重试。')
      }
    },
    async refundExtProduct () {
      this.refundConfirmLoading = true

      try {
        await refundExtProduct({
          orderId: this.detail.orderId,
          orderIds: [ this.id ],
          refundType: 'UNCONSTRAINT',
          remark: '',
          type: 'OTHER'
        })

        this.refundConfirmLoading = false
        this.refundModVisible = false
        this.$message.success('辅营订单退订成功，正在刷新订单...', () => {
          window.location.reload()
        })
      } catch (err) {
        this.refundConfirmLoading = false
        this.refundModVisible = false
        this.$message.error(err.message || '退订辅营失败，请稍候重试。')
      }
    }
  },
  components: {

  }
}
</script>

<style lang="less">
  .order-base-header {
    &.aclry-base-header {
      color: @primary-color;
      padding-bottom: 5px;
      border-bottom: 1px solid #b7b7b7;
      margin-bottom: 0;
    }
  }

  .order-primary-header {
    &.aclry-primary-header {
      border-bottom: 0;
      margin-bottom: 0;

      .header-msg {
        display: inline-block;
        font-size: 14px;
        margin-left: -10px;
        padding: 10px 0;
      }

    }
  }

  .order-gray-table-outer {
    &.aclry-table-outer {
      background: #fff;
      padding: 10px 0;
    }
  }

  .base-info {
    margin-top: 50px;
  }

  .pass-info {
    margin-top: 50px;
  }

  .ext-product-info {
    margin-top: 50px;
  }

  .order-tips {
    margin: 20px 0;
    color: @primary-color;
  }

  .ext-order-table {
    text-align: center;

    &.order-default-table tbody tr td {
      padding: 14px 10px;
    }

    &.order-default-table tbody tr td:first-child {
      padding-left: 18px;
    }

    .seg-line {
      position: relative;
    }

    .seg-tip {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      color: #fff;
      text-decoration: none;

      span {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        font-style: normal;
        margin: 3px;
        font-size: 10px;
      }

      &:before {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-top: 30px solid red;
        border-right: 30px solid transparent;
      }

      &.seg-old {
        &:before {
          border-top: 30px solid #808080;
        }
      }
    }
  }

  .change-notice {
    margin-top: 16px;
  }

  /*订单弹窗样式*/
  .order-modal {
    .ant-modal-title {
      margin: 0;
      font-size: 18px;
      line-height: 22px;
      font-weight: bold;
      color: #fff;
    }
    .ant-modal-content {
      position: relative;
      background-color: #fff;
      border: 0;
      border-radius: 0;
      background-clip: padding-box;
    }
    .ant-modal-header {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      padding: 16px 24px;
      border-radius: 0;
      background: @primary-color;
      color: #fff;
    }
    .ant-modal-body {
      padding: 24px;
      font-size: 12px;
      line-height: 1.5;
      word-wrap: break-word;
    }
    .ant-modal-footer {
      border-top: 0;
      padding: 0 16px 40px;
      text-align: center;
      border-radius: 0;
    }

    &.pay-modal {
      .ant-modal-body {
        padding: 0;
      }

      .ant-modal-footer {
        border-top: 0;
        padding: 16px;
        text-align: right;
        border-radius: 0;
        background: #f5f5f5;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .ext-order-table-warp {
      overflow-x: scroll;
    }
  }

</style>
